// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import * as angular from 'angular';
import { app } from '../../app';
import { SpAlert } from '../../components/sp-alert/sp-alert.model';
import { u2f } from '../../lib/u2f-api';

app.factory('HardTokenEditModal', modal);

/** @ngInject */
function modal($uibModal) {

    return function (token) {

        return $uibModal.open({
            templateUrl: require('./hard-token-edit.html'),
            controller: controller
        }).result
            .finally(() => {
                /* workaround to overcome incompatibility with non-$uibModal */
                /* todo: delete after all modals are converted to $uibModal */
                $('body').removeClass('modal-open');
                $('.modal-backdrop').remove();
            });

        /** @ngInject */
        function controller(
            $scope,
            $state,
            $uibModalInstance,
            Alert,
            DestructiveOperationModal,
            HardTokenService,
            HardTokenResource,
            UsersResource,
        ) {

            restoreToken();

            $scope.cancel = cancel;
            $scope.search = search;
            $scope.assignHardTokenToUser = assignHardTokenToUser;
            $scope.unAssingTokenSecondary = unAssingTokenSecondary;
            $scope.close = close;
            $scope.save = save;
            $scope.disable = disable;
            $scope.enable = enable;
            $scope.showDeleteModal = showDeleteModal;
            $scope.u2fRegistrationStart = u2fRegistrationStart;
            $scope.u2fAuthenticationStart = u2fAuthenticationStart;
            $scope.canRegister = canRegister;
            $scope.searchinput={text: ''};
            $scope.spAlert = null;
            $scope.selectedCompanyUser = null;
            $scope.isSearching = false;

            function search() {

                $scope.spAlert = null;
                $scope.selectedCompanyUser = null;
                $scope.isSearching = true;
                const companyId = $state.params.companyId;

                UsersResource
                    .getCompanyUserForSaaspassUser(companyId,$scope.searchinput.text)
                    .then((companyUser) => {
                        if (companyUser.saaspassUser.userType !== "SMS_USER")
                            $scope.selectedCompanyUser = companyUser;
                        else
                            $scope.spAlert=new SpAlert('danger', 'hard_tokens.edit.failed_assign', false);
                        // if (companyUser.roleType === "END_USER")
                        //     $scope.spAlert=new SpAlert('danger', 'hard_tokens.edit.failed_save', false);
                        // else
                        //     $scope.selectedCompanyUser = companyUser
                    })
                    .catch((response) => {
                        if (response.status === 404) {
                            $scope.spAlert=new SpAlert('danger', 'company.user-directories.manage-account.verify.user-not-found', false);
                        }
                    })
                    .finally(() => $scope.isSearching = false);
            }

            function assignHardTokenToUser() {
                const companyId = $state.params.companyId;
                HardTokenResource
                    .assingTokenAsSecondary(companyId,$scope.selectedCompanyUser.id,$scope.token.id)
                    .then(() => {
                        Alert('success', 'company.user-directories.manage-user.device_assigned');
                        $state.go(
                            'company.user-directories.manage-user',
                            {companyUserId: $scope.selectedCompanyUser.id}
                        );
                    })
            }
            function unAssingTokenSecondary(token){
                const companyId = $state.params.companyId;
                HardTokenResource
                    .unAssingTokenAsSecondary(companyId,token.companyUserId,token.id)
                    .then((data) => {
                        Alert('success', 'company.user-directories.manage-user.device_unassigned');
                        $state.reload($state.current);
                    })
            }

            function cancel() {
                restoreToken();
            }

            function initInputs() {
                $scope.edit = {};
                $scope.show = {};
            }

            function replaceToken(value) {
                initInputs();
                angular.copy(value, $scope.token);
                angular.copy(value, token);
            }

            function updateToken(value) {
                initInputs();
                angular.extend($scope.token, value);
                angular.extend(token, value);
            }

            function restoreToken() {
                initInputs();
                $scope.token = angular.copy(token);
            }

            function close() {
                $scope.token.secret=null;
                return $uibModalInstance.dismiss();
            }

            function save() {

                HardTokenService
                    .save($scope.token)
                    .then(success)
                    .catch(error);

                function success(response) {
                    replaceToken(response);

                    $scope.spAlert = new SpAlert('success', 'hard_tokens.edit.saved_successfully');
                }

                function error() {
                    restoreToken();
                    $scope.spAlert = new SpAlert('danger', 'hard_tokens.edit.failed_save');
                }
            }

            function disable() {

                HardTokenService
                    .disable(token)
                    .then(success)
                    .catch(error);

                function success() {

                    updateToken({status: 'INACTIVE'});
                    $state.reload($state.current);
                    $scope.spAlert = new SpAlert('success', 'hard_tokens.edit.disabled_successfully');
                }

                function error() {
                    restoreToken();
                    $scope.spAlert = new SpAlert('danger', 'hard_tokens.edit.failed_to_disable');
                }
            }

            function enable() {

                HardTokenService
                    .enable(token)
                    .then(success)
                    .catch(error);

                function success() {

                    updateToken({status: 'ACTIVE'});
                    $state.reload($state.current);
                    $scope.spAlert = new SpAlert('success', 'hard_tokens.edit.enabled_successfully');
                }

                function error() {
                    restoreToken();
                    $scope.spAlert = new SpAlert('danger', 'hard_tokens.edit.failed_to_enable');
                }
            }
            function showDeleteModal() {
                const companyId = $state.params.companyId;
                const url = `app/rest/admin/company/${companyId}/hardtoken/${token.id}`;
                DestructiveOperationModal({
                    titleKey: 'hard_tokens.management.delete',
                    textKey: $scope.token.isSecondaryDeviceOfUser?'hard_tokens.management.info_secondarydevice':'hard_tokens.management.info',
                    http: {method: 'DELETE', url}
                }).then(() => successfulDelete());


            }
            function successfulDelete() {
                close();
                $state.go('company.hard-token-management', {}, {reload: true});
                Alert('success', 'hard_tokens.management.delete.success');
            }

            function canRegister() {
                return token.otpType == 'U2F'
                    && $scope.token.otpType == 'U2F';
            }

            function u2fRegistrationStart() {

                HardTokenService
                    .u2fRegistrationStart(token)
                    .then(success)
                    .catch(error);

                function success(response) {

                    $scope.spAlert = new SpAlert('success', 'hard_tokens.edit.U2F_registration');

                    u2f.register(response.registerRequests, response.authenticateRequests, data => {

                        if (!data.errorCode) {
                            u2fRegistrationFinish(data);
                            return;
                        }

                        const key = 'hard_tokens.edit.U2F_failed_error';
                        const variables = {errorCode: data.errorCode};
                        $scope.spAlert = new SpAlert('danger', key, variables);
                    });
                }

                function error() {
                    $scope.spAlert = new SpAlert('danger', 'hard_tokens.edit.U2F_failed');
                }
            }

            function u2fRegistrationFinish(data) {

                HardTokenService
                    .u2fRegistrationFinish(token, data)
                    .then(success)
                    .catch(error);

                function success(response) {

                    replaceToken(response);

                    const key = 'hard_tokens.edit.U2F_registration_successfully';
                    $scope.spAlert = new SpAlert('success', key);
                }

                function error() {
                    $scope.spAlert = new SpAlert('danger', 'hard_tokens.edit.U2F_failed');
                }
            }

            function u2fAuthenticationStart() {

                HardTokenService
                    .u2fAuthenticationStart(token)
                    .then(success)
                    .catch(error);

                function success(response) {

                    $scope.spAlert = new SpAlert('success', 'hard_tokens.edit.U2F_test');

                    u2f.sign(response.authenticateRequests, data => {

                        if (!data.errorCode) {
                            u2fAuthenticationFinish(data);
                            return;
                        }

                        const key = 'hard_tokens.edit.authentication_test_fail_error';
                        const variables = {errorCode: data.errorCode};
                        $scope.spAlert = new SpAlert('danger', key, variables);
                    });
                }

                function error() {
                    const key = 'hard_tokens.edit.authentication_test_failed';
                    $scope.spAlert = new SpAlert('danger', key);
                }
            }

            function u2fAuthenticationFinish(authdata) {

                HardTokenService
                    .u2fAuthenticationFinish(token, authdata)
                    .then(success)
                    .catch(error);

                function success() {
                    const key = 'hard_tokens.edit.authentication_test_successfully';
                    $scope.spAlert = new SpAlert('success', key);
                }

                function error() {
                    const key = 'hard_tokens.edit.authentication_test_failed';
                    $scope.spAlert = new SpAlert('danger', key);
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/portal/modals/hard-token-edit/hard-token-edit.modal.js